import React from "react";

import { Modal, EmptyState } from "@toddle-edu/ds-web";
import { NoAccessIllustration, colors } from "@toddle-edu/ds-theme";

import { useI18n } from "Hooks";

import classes from "./AIUsageLimit.scss";

const styles = {
  subtitleStyle: {
    color: colors.textDefault,
    lineHeight: "2.4rem",
  },
};

const AIUsageLimit = props => {
  const { setIsAIUsageLimitModalOpen, showAIUsageLimitModal } = props;

  const { t } = useI18n(["common"]);

  const handleClose = () => {
    setIsAIUsageLimitModalOpen(false);
  };

  return (
    <Modal
      height="416px"
      width="554px"
      isOpen={showAIUsageLimitModal}
      onClose={handleClose}
    >
      <Modal.Header title={t("common:usage_limit_reached")} isClosable={true} />
      <Modal.Body>
        <div className={classes.container}>
          <EmptyState
            illustration={NoAccessIllustration}
            subtitle={t("common:usage_limit_reached_empty_msg")}
            subtitleStyle={styles.subtitleStyle}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AIUsageLimit;
